import { render, staticRenderFns } from "./dbCompareListComponent.vue?vue&type=template&id=7042f989"
import script from "./dbCompareListComponent.vue?vue&type=script&lang=js"
export * from "./dbCompareListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports